import { useQuery } from '@tanstack/react-query'

import { useAuthState } from '@/hooks/auth'
import { serializeUser } from '@/lib/auth-redirect'
import { apiClient } from '@/services/apiClients'

import { Role } from './types'

export const useUser = () => {
  const { isAuthenticated, user: cookieUser } = useAuthState()
  const context = useQuery({
    queryKey: ['api/user'],
    queryFn: () => apiClient.get<StatusResponse<any>>('api/user'),
    enabled: isAuthenticated,
    select: data => serializeUser(data?.data?.data as any),
  })

  const user = context.data ?? cookieUser

  return {
    user,
    role: user?.profile as Role,
  }
}
